<template>
  <div class="container">
    <h1>M.Y. Sleep</h1>

    <template v-if="sleep_data_loading">
      <h3>
        Collecting data ...
      </h3>
    </template>
    <template v-else>

      <button @click="setSortByLastOrderDate" class="sort_button">Order Date</button>
      <button @click="setSortBySleepQty" class="sort_button">Quantity</button>
      <button @click="setSortByAvgDay" class="sort_button">Average per Day</button>

      <template v-if="sort_asc_desc === 1">
        <button @click="getLowToHighData" class="lowhigh_button">Sort Low to High</button>
      </template>
      <template v-else>
        <button @click="getHighToLowData" class="lowhigh_button">Sort High to Low</button>
      </template>

      <template v-if="sort_asc_desc === 1">
        <h5>Sorted by {{sort_key_selected_text}} (High to Low)</h5>
      </template>
      <template v-else>
        <h5>Sorted by {{sort_key_selected_text}} (Low to High)</h5>
      </template>

      <div class="row">
        <div class="col-12">
            <table class="table table-striped table-bordered table-hover table-condensed align_left">
              <thead>
              <tr>
                <th>#</th>
                <th>Dispensary</th>
                <th>First Order Date</th>
                <th>Last Order Date</th>
                <th style="white-space:nowrap;">Total Qty</th>
                <th style="white-space:nowrap;">Average Day</th>
              </tr>
              </thead>
              <tbody class="align_left">
              <tr v-for="(sleep_data_pos) in sleep_data_array_selected" v-bind:key="sleep_data_pos.pos">
                <td>{{sleep_data_pos.pos}}</td>
  <!--              <td style="white-space:nowrap;">{{sleep_data_pos.customer_display_name}}</td>-->
                <td style="cursor: pointer; text-decoration: underline" v-on:click="show_customer_detail_page(sleep_data_pos.customer_id)">{{sleep_data_pos.customer_display_name}}</td>

                <td style="white-space:nowrap;">{{sleep_data_pos.first_order_date}}</td>
                <td style="white-space:nowrap;">{{sleep_data_pos.last_order_date}}</td>
                <td>{{sleep_data_pos.sum_qty_sleep}}</td>
                <td>{{sleep_data_pos.order_average}}</td>
              </tr>
              </tbody>
            </table>

        </div>
      </div>
    </template>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      sleep_data_array_selected: [],
      sort_asc_desc: 0,
      sort_key_selected: 1,
      sort_key_selected_text: '',
    }
  },
  computed: {
    ...mapGetters({
       sleep_data: 'admin/sleep_data',
       sleep_data_loading: 'admin/sleep_data_loading',
    }),
  },
  watch: {
    sleep_data: async function () {
      if(localStorage.getItem('sleep_sort_key_selected') === null) {
        this.setSortByLastOrderDate();
      }
      if(localStorage.getItem('sleep_sort_key_selected') === "1") {
        this.setSortByLastOrderDate();
      }
      if(localStorage.getItem('sleep_sort_key_selected') === "2") {
        this.setSortBySleepQty();
      }
      if(localStorage.getItem('sleep_sort_key_selected') === "3") {
        this.setSortByAvgDay();
      }
    },
  },
  mounted() {
    this.get_sleep_data();
  },
  methods: {
    get_sleep_data() {
      if(this.sleep_data.length === 0) {

        if(localStorage.getItem('sleep_lthtl') === 'lth') {
          this.$store.dispatch('admin/getSleepData', {type: 'lth'});
          this.sort_asc_desc = 0;
          localStorage.setItem('sleep_sort_asc_desc', "0");
        }
        if(localStorage.getItem('sleep_lthtl') === null) {
          this.$store.dispatch('admin/getSleepData', {type: 'lth'});
          localStorage.setItem('sleep_lthtl', "lth");
          this.sort_asc_desc = 0;
          localStorage.setItem('sleep_sort_asc_desc', "0");
        }
        if(localStorage.getItem('sleep_lthtl') === 'htl') {
          this.$store.dispatch('admin/getSleepData', {type: 'htl'});
          this.sort_asc_desc = 1;
          localStorage.setItem('sleep_sort_asc_desc', "1");
        }
      }
      else {

        if(localStorage.getItem('sleep_sort_key_selected') === null) {
          this.setSortByLastOrderDate();
        }
        if(localStorage.getItem('sleep_sort_key_selected') === "1") {
          this.setSortByLastOrderDate();
        }
        if(localStorage.getItem('sleep_sort_key_selected') === "2") {
          this.setSortBySleepQty();
        }
        if(localStorage.getItem('sleep_sort_key_selected') === "3") {
          this.setSortByAvgDay();
        }

        if(localStorage.getItem('sleep_sort_key_selected_text') === null) {
          this.sort_key_selected_text = 'Order Date';
        } else {
          this.sort_key_selected_text = localStorage.getItem('sleep_sort_key_selected_text');
        }

        if(localStorage.getItem('sleep_sort_asc_desc') === null) {
          this.sort_asc_desc = 0;
        } else {
          this.sort_asc_desc = Number(localStorage.getItem('sleep_sort_asc_desc'));
        }

      }
    },
    setSortByLastOrderDate() {
      this.sleep_data_array_selected = this.sleep_data.data.last_order_date;
      this.sort_key_selected = 1;
      localStorage.setItem('sleep_sort_key_selected', "1");
      this.sort_key_selected_text = 'Order Date';
      localStorage.setItem('sleep_sort_key_selected_text', 'Order Date');
    },
    setSortBySleepQty() {
      this.sleep_data_array_selected = this.sleep_data.data.sleep_qty;
      this.sort_key_selected = 2;
      localStorage.setItem('sleep_sort_key_selected', "2");
      this.sort_key_selected_text = 'Quantity';
      localStorage.setItem('sleep_sort_key_selected_text', 'Quantity');
    },
    setSortByAvgDay() {
      this.sleep_data_array_selected = this.sleep_data.data.avg_day;
      this.sort_key_selected = 3;
      localStorage.setItem('sleep_sort_key_selected', "3");
      this.sort_key_selected_text = 'Average';
      localStorage.setItem('sleep_sort_key_selected_text', 'Average');
    },
    getLowToHighData() {
      this.$store.dispatch('admin/getSleepData', {type: 'lth'});
      localStorage.setItem('sleep_lthtl', "lth");
      this.sort_asc_desc = 0;
      localStorage.setItem('sleep_sort_asc_desc', "0");
    },
    getHighToLowData() {
      this.$store.dispatch('admin/getSleepData', {type: 'htl'});
      localStorage.setItem('sleep_lthtl', "htl");
      this.sort_asc_desc = 1;
      localStorage.setItem('sleep_sort_asc_desc', "1");
    },
    show_customer_detail_page(customer_id) {
      this.$router.push({name: "customer_details", 'params':{customer_id: customer_id} });
    },

  }
}
</script>


<style scoped>

.lowhigh_button {
  color: black;
  background-color: lightcoral;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
  padding-bottom: 4px;
  border-radius: 5px;
  border-style: hidden;
  font-weight: 500;
  margin-top: 10px;
  margin-left: 20px;
  margin-bottom: 10px;
}

.sort_button {
  color: black;
  background-color: lightskyblue;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
  padding-bottom: 4px;
  border-radius: 5px;
  border-style: hidden;
  font-weight: 500;
  margin-top: 10px;
  margin-left: 10px;
  margin-bottom: 10px;
}

.full_page {
  margin-left: 20px;
  margin-right: 20px;
}

</style>

